"use client";
import { useState, useMemo } from "react";
import CustomSelect from "../../design1/components/ui/form/CustomSelect";
import Link from "next/link";
import { Card } from "./Services";
import CardGrid from "src/app/components/CardGrid";
import Skeleton from "react-loading-skeleton";
import { ContactCard } from "../../design2/ContactUs2";
import { CardInfo } from "../../design2/ContactUs2";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import { Switch2 } from "../../design2/components/ButtonSwitch";
import { useCompanyStaff } from "src/app/lib/useCompanyStaff";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { newData } from "../../design1/components";
import ContactForm from "../../design1/components/ContactUsForm";
import { ParentCard } from "../../design1/PropertyPage1";
import React from "react";
import { CustomHero } from "../Pages/Branches3";
import StyledWraper from "./StyledWraper";
import { MemberType } from "src/types";
import { useDirectors } from "src/app/lib/useCompanyDirector";

const FacebookIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M20.5 9.00195H18.25C17.2554 9.00195 16.3016 9.39704 15.5983 10.1003C14.8951 10.8036 14.5 11.7574 14.5 12.752V15.002H12.25V18.002H14.5V24.002H17.5V18.002H19.75L20.5 15.002H17.5V12.752C17.5 12.553 17.579 12.3623 17.7197 12.2216C17.8603 12.081 18.0511 12.002 18.25 12.002H20.5V9.00195Z"
        fill="white"
      />
    </svg>
  );
};
const LinkedinIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M18.5 14C19.4946 14 20.4484 14.3951 21.1517 15.0983C21.8549 15.8016 22.25 16.7554 22.25 17.75V22.125H19.75V17.75C19.75 17.4185 19.6183 17.1005 19.3839 16.8661C19.1495 16.6317 18.8315 16.5 18.5 16.5C18.1685 16.5 17.8505 16.6317 17.6161 16.8661C17.3817 17.1005 17.25 17.4185 17.25 17.75V22.125H14.75V17.75C14.75 16.7554 15.1451 15.8016 15.8483 15.0983C16.5516 14.3951 17.5054 14 18.5 14Z"
        fill="white"
      />
      <path d="M12.25 14.625H9.75V22.125H12.25V14.625Z" fill="white" />
      <path
        d="M11 12.75C11.6904 12.75 12.25 12.1904 12.25 11.5C12.25 10.8096 11.6904 10.25 11 10.25C10.3096 10.25 9.75 10.8096 9.75 11.5C9.75 12.1904 10.3096 12.75 11 12.75Z"
        fill="white"
      />
    </svg>
  );
};
const InstagramIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M19.125 10.25H12.875C11.1491 10.25 9.75 11.6491 9.75 13.375V19.625C9.75 21.3509 11.1491 22.75 12.875 22.75H19.125C20.8509 22.75 22.25 21.3509 22.25 19.625V13.375C22.25 11.6491 20.8509 10.25 19.125 10.25Z"
        fill="white"
      />
      <path
        d="M18.5003 16.106C18.5774 16.6261 18.4886 17.1573 18.2464 17.6241C18.0042 18.0908 17.621 18.4693 17.1513 18.7057C16.6816 18.9422 16.1493 19.0244 15.6302 18.9409C15.111 18.8574 14.6314 18.6123 14.2596 18.2404C13.8878 17.8686 13.6426 17.389 13.5591 16.8698C13.4756 16.3507 13.5578 15.8184 13.7943 15.3487C14.0307 14.879 14.4092 14.4958 14.8759 14.2536C15.3427 14.0114 15.8739 13.9226 16.3941 13.9997C16.9246 14.0784 17.4158 14.3256 17.7951 14.7049C18.1744 15.0842 18.4216 15.5754 18.5003 16.106Z"
        stroke="var(--primary-color)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.4375 13.0625H19.445"
        stroke="var(--primary-color)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const TwitterIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M21.625 9.75H10.375C10.0766 9.75 9.79048 9.86853 9.5795 10.0795C9.36853 10.2905 9.25 10.5766 9.25 10.875V22.125C9.25 22.4234 9.36853 22.7095 9.5795 22.9205C9.79048 23.1315 10.0766 23.25 10.375 23.25H21.625C21.9234 23.25 22.2095 23.1315 22.4205 22.9205C22.6315 22.7095 22.75 22.4234 22.75 22.125V10.875C22.75 10.5766 22.6315 10.2905 22.4205 10.0795C22.2095 9.86853 21.9234 9.75 21.625 9.75ZM19.773 19.477C19.8252 19.5293 19.8667 19.5913 19.895 19.6596C19.9233 19.7279 19.9378 19.8011 19.9378 19.875C19.9378 19.9489 19.9233 20.0221 19.895 20.0904C19.8667 20.1587 19.8252 20.2207 19.773 20.273C19.7207 20.3252 19.6587 20.3667 19.5904 20.395C19.5221 20.4233 19.4489 20.4378 19.375 20.4378C19.3011 20.4378 19.2279 20.4233 19.1596 20.395C19.0913 20.3667 19.0293 20.3252 18.977 20.273L16 17.2952L13.023 20.273C12.9174 20.3785 12.7743 20.4378 12.625 20.4378C12.4757 20.4378 12.3326 20.3785 12.227 20.273C12.1215 20.1674 12.0622 20.0243 12.0622 19.875C12.0622 19.7257 12.1215 19.5826 12.227 19.477L15.2048 16.5L12.227 13.523C12.1215 13.4174 12.0622 13.2743 12.0622 13.125C12.0622 12.9757 12.1215 12.8326 12.227 12.727C12.3326 12.6215 12.4757 12.5622 12.625 12.5622C12.7743 12.5622 12.9174 12.6215 13.023 12.727L16 15.7048L18.977 12.727C19.0826 12.6215 19.2257 12.5622 19.375 12.5622C19.5243 12.5622 19.6674 12.6215 19.773 12.727C19.8785 12.8326 19.9378 12.9757 19.9378 13.125C19.9378 13.2743 19.8785 13.4174 19.773 13.523L16.7952 16.5L19.773 19.477Z"
        fill="white"
      />
    </svg>
  );
};
const YoutubeIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M22.5879 13.0125C22.5136 12.7159 22.3624 12.4441 22.1495 12.2246C21.9366 12.0052 21.6696 11.8457 21.3754 11.7625C20.3004 11.5 16.0004 11.5 16.0004 11.5C16.0004 11.5 11.7004 11.5 10.6254 11.7875C10.3311 11.8707 10.0641 12.0302 9.8512 12.2496C9.6383 12.4691 9.4871 12.7409 9.41286 13.0375C9.21612 14.1285 9.11988 15.2352 9.12536 16.3437C9.11834 17.4607 9.21459 18.5758 9.41286 19.675C9.49471 19.9624 9.6493 20.2238 9.8617 20.434C10.0741 20.6443 10.3371 20.7961 10.6254 20.875C11.7004 21.1625 16.0004 21.1625 16.0004 21.1625C16.0004 21.1625 20.3004 21.1625 21.3754 20.875C21.6696 20.7918 21.9366 20.6323 22.1495 20.4129C22.3624 20.1934 22.5136 19.9216 22.5879 19.625C22.7831 18.5422 22.8793 17.444 22.8754 16.3437C22.8824 15.2268 22.7861 14.1117 22.5879 13.0125Z"
        fill="white"
      />
      <path
        d="M14.5938 18.3883L18.1875 16.3445L14.5938 14.3008V18.3883Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const TikTokIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M19.0433 12.38C18.5877 11.8597 18.3366 11.1916 18.3367 10.5H16.2767V18.7667C16.2611 19.2141 16.0723 19.6381 15.7502 19.949C15.4281 20.2599 14.9977 20.4336 14.55 20.4333C13.6033 20.4333 12.8167 19.66 12.8167 18.7C12.8167 17.5533 13.9233 16.6933 15.0633 17.0467V14.94C12.7633 14.6333 10.75 16.42 10.75 18.7C10.75 20.92 12.59 22.5 14.5433 22.5C16.6367 22.5 18.3367 20.8 18.3367 18.7V14.5067C19.172 15.1066 20.1749 15.4284 21.2033 15.4267V13.3667C21.2033 13.3667 19.95 13.4267 19.0433 12.38Z"
        fill="white"
      />
    </svg>
  );
};

const customIcons = {
  facebook: <FacebookIcon />,
  instagram: <InstagramIcon />,
  linkedin: <LinkedinIcon />,
  x: <TwitterIcon />, // Twitter is now "X"
  youtube: <YoutubeIcon />,
  tiktok: <TikTokIcon />,
};

const ContactUs3 = () => {
  const [activeBranch, setActiveBranch] = useState<1 | 2>(1); // Default is 1
  const { data, isLoading: loadingInfo } = useFetchCompanyInfo();
  const services = data?.companyServices;
  const filteredServices = newData.filter((service) =>
    services?.includes(service.assessor)
  );
  const { data: staffData, isLoading: staffLoading } = useCompanyStaff();
  const { data: directorsData, isLoading: directorsLoading } = useDirectors();
  const isLoading = staffLoading || directorsLoading;
  // Using useMemo to memoize the derived list of unique branches
  const options = useMemo(() => {
    const branches = staffData?.staff?.map((item) => item.branch);
    const uniqueBranches = new Set(branches);
    return Array.from([...uniqueBranches, "All branches", "Directors"]).map(
      (branch) => ({
        label: branch as string,
        value: branch as string,
      })
    );
  }, [staffData]);

  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const members = useMemo(() => {
    if (!selectedValue || selectedValue === "Directors") {
      return directorsData || [];
    }
    if (selectedValue === "All branches") {
      return staffData?.staff || [];
    }
    return (
      staffData?.staff?.filter((item) => item.branch === selectedValue) || []
    );
  }, [selectedValue, staffData?.staff, directorsData]);

  // Efficient handler for select change
  const handleSelect = (value: string) => {
    setSelectedValue(value); // Updating state

  };

  return (
    <section className="max-w-full overflow-clip">
      <CustomHero
        text={`Stay Your next move starts here-browse, find, and secure your perfect property today!" Your next move starts here-browse, find, and secure `}
        header="Contacts & Services"
      />
      <div className="wrapper py-10">
        <div className="first flex gap-[10%] justify-between">
          <Switch2
            disable={filteredServices.length > 0 ? 0 : 2}
            button1Text="Contacts"
            button2Text="Services"
            activeState={activeBranch}
            onSwitch={(newState) => setActiveBranch(newState)}
          />
          <span className={`${activeBranch === 1 ? "block" : "hidden"}`}>
            {members && members.length > 0 && (
              <div className="border rounded-md border-themeColor p-2">
                <CustomSelect
                  options={options}
                  value={selectedValue}
                  onChange={setSelectedValue}
                  handleSelect={handleSelect}
                  placeholder="All branches"
                />
              </div>
            )}
          </span>
        </div>
        {activeBranch === 1 && (
          <div className="grid-container mt-8 !lg:grid-cols-1 relative">
            <div className="first h-max flex flex-col gap-4">
              <StyledWraper>
                <ParentCard header="Contact Details">
                  <ContactForm
                    email={data?.companyInfo?.email as string}
                    variant
                  />
                </ParentCard>
              </StyledWraper>

              <Contact
                loading={loadingInfo}
                email={data?.companyInfo?.email}
                address={data?.companyInfo?.head_office_address}
                phone={data?.companyInfo?.phone_number}
              />
            </div>
            <SecondCol members={members as MemberType[]} loading={isLoading} />
          </div>
        )}
        {activeBranch === 2 && (
          <div className="">
            <div className="mt-8">
              {filteredServices && filteredServices.length > 0 ? (
                <div className="grid grid-cols-3 lg:grid-cols-2 sm:!grid-cols-1 gap-8">
                  {filteredServices.map((item, index) => {
                    return (
                      <StyledWraper
                        className="w-full min-h-[180px] select-none"
                        key={index}
                      >
                        <Card {...item} />
                      </StyledWraper>
                    );
                  })}
                </div>
              ) : (
                <div>No data available</div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
export default ContactUs3;

const SecondCol: React.FC<{ members: MemberType[]; loading: boolean }> = ({
  members,
  loading,
}) => {
  return (
    <StyledWraper className=" h-max sticky top-[80px]">
      <div className="items relative bg-white  scrollbar-hide overflow-auto !max-h-[800px] rounded-xl shadow-md ">
        <div className="first bg-white sticky top-0 px-2 pt-2 flex justify-between">
          <h4 className=" bg-white top-0">Contact staff</h4>
        </div>
        {loading ? (
          <Skeleton count={8} height={120} className="w-full" />
        ) : members && members.length > 0 ? (
          <CardGrid maxColumns={1}>
            {members.map((item, index) => (
              <ContactCard key={index} {...item} />
            ))}
          </CardGrid>
        ) : (
          <div className="p-2">
            No staff information attached yet. Please try again later.
          </div>
        )}
      </div>
    </StyledWraper>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6673 5.02344V11.3334C14.6673 11.8436 14.4724 12.3344 14.1225 12.7056C13.7725 13.0768 13.2939 13.3002 12.7847 13.3301L12.6673 13.3334H3.33398C2.82384 13.3335 2.33297 13.1386 1.96181 12.7886C1.59065 12.4386 1.36725 11.96 1.33732 11.4508L1.33398 11.3334V5.02344L7.63065 9.22144L7.70798 9.26544C7.79912 9.30997 7.89922 9.33311 8.00065 9.33311C8.10208 9.33311 8.20218 9.30997 8.29332 9.26544L8.37065 9.22144L14.6673 5.02344Z"
        fill="var(--primary-color)"
      />
      <path
        d="M12.6675 2.66797C13.3875 2.66797 14.0189 3.04797 14.3709 3.6193L8.00086 7.86597L1.63086 3.6193C1.79805 3.34785 2.02772 3.1203 2.30071 2.95563C2.5737 2.79095 2.88209 2.69393 3.20019 2.67264L3.33419 2.66797H12.6675Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const Contact: React.FC<{
  phone?: string[];
  email?: string;
  address?: string;
  loading?: boolean;
}> = ({ phone, address, email, loading }) => {
  const { socialMediaLinks, loading: loadingSocialMedia } =
    useFetchValidSocialMediaLinks(customIcons);

  return (
    <StyledWraper>
      <ParentCard header="Head Office">
        <div className="flex-col mt-6 flex gap-7">
          {loading ? (
            <Skeleton count={3} className="w-full block my-1" height={80} />
          ) : (
            <>
              {Array.isArray(phone) && phone.filter(Boolean).length > 0 && (
                <CardInfo variant icon={<BillCallIcon />} title="Phone Number">
                  <div className="flex flex-wrap gap-4">
                    {phone.map(
                      (num, index) =>
                        num && (
                          <Link
                            key={index}
                            href={`tel:${num}`}
                            className="hover:underline"
                          >
                            {num}
                          </Link>
                        )
                    )}
                  </div>
                </CardInfo>
              )}
              {address && (
                <CardInfo variant icon={<LocationIcon />} title="Location">
                  <div className="flex gap-4">
                    <AddressLink address={address} />
                  </div>
                </CardInfo>
              )}
              {email && (
                <CardInfo variant icon={<Message2Icon />} title="Email Address">
                  <EmailLink email={email} />
                </CardInfo>
              )}
            </>
          )}
          {(loadingSocialMedia || socialMediaLinks.length > 0) && (
            <div className="items w-max mb-8 mt-5 mx-auto">
              <h5 className="text-center mb-4">Follow us</h5>

              {loadingSocialMedia ? (
                <Skeleton
                  containerClassName="flex gap-1"
                  count={6}
                  height={33}
                  width={33}
                />
              ) : (
                <div className="flex items-center gap-4">
                  {socialMediaLinks.map((item, index) => (
                    <Link href={item.url} key={index}>
                      {item.icon}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </ParentCard>
    </StyledWraper>
  );
};

const BillCallIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.5889 36.8884C25.1889 36.8001 18.3873 35.8601 11.2639 28.7384C4.14228 21.6151 3.20394 14.8151 3.11394 12.4134C2.98061 8.75345 5.78395 5.19845 9.02228 3.81012C9.41224 3.64173 9.83928 3.57762 10.2615 3.62407C10.6837 3.67053 11.0866 3.82596 11.4306 4.07511C14.0973 6.01845 15.9373 8.95845 17.5173 11.2701C17.8649 11.778 18.0136 12.396 17.9349 13.0064C17.8562 13.6169 17.5557 14.177 17.0906 14.5801L13.8389 16.9951C13.6818 17.1086 13.5713 17.2752 13.5277 17.464C13.4842 17.6528 13.5107 17.851 13.6023 18.0218C14.3389 19.3601 15.6489 21.3534 17.1489 22.8534C18.6489 24.3534 20.7373 25.7501 22.1689 26.5701C22.3484 26.6709 22.5597 26.699 22.7594 26.6488C22.959 26.5986 23.1318 26.4738 23.2423 26.3001L25.3589 23.0784C25.7481 22.5615 26.3222 22.2152 26.9609 22.1121C27.5997 22.0089 28.2535 22.1569 28.7856 22.5251C31.1306 24.1484 33.8673 25.9568 35.8706 28.5218C36.14 28.8683 36.3113 29.2808 36.3668 29.7162C36.4222 30.1516 36.3596 30.5938 36.1856 30.9968C34.7906 34.2518 31.2606 37.0234 27.5889 36.8884Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const LocationIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 17.5C21.3807 17.5 22.5 16.3807 22.5 15C22.5 13.6193 21.3807 12.5 20 12.5C18.6193 12.5 17.5 13.6193 17.5 15C17.5 16.3807 18.6193 17.5 20 17.5Z"
        fill="var(--primary-color)"
      />
      <path
        d="M20 2.5C13.1078 2.5 7.5 7.86328 7.5 14.4531C7.5 17.5914 8.93047 21.7648 11.7516 26.8578C14.0172 30.9469 16.6383 34.6445 18.0016 36.4844C18.2319 36.7987 18.5331 37.0544 18.8807 37.2306C19.2284 37.4069 19.6126 37.4987 20.0023 37.4987C20.3921 37.4987 20.7763 37.4069 21.1239 37.2306C21.4716 37.0544 21.7728 36.7987 22.0031 36.4844C23.3641 34.6445 25.9875 30.9469 28.2531 26.8578C31.0695 21.7664 32.5 17.593 32.5 14.4531C32.5 7.86328 26.8922 2.5 20 2.5ZM20 20C19.0111 20 18.0444 19.7068 17.2221 19.1573C16.3999 18.6079 15.759 17.827 15.3806 16.9134C15.0022 15.9998 14.9031 14.9945 15.0961 14.0245C15.289 13.0546 15.7652 12.1637 16.4645 11.4645C17.1637 10.7652 18.0546 10.289 19.0245 10.0961C19.9945 9.90315 20.9998 10.0022 21.9134 10.3806C22.827 10.759 23.6079 11.3999 24.1573 12.2221C24.7068 13.0444 25 14.0111 25 15C24.9986 16.3256 24.4713 17.5966 23.5339 18.5339C22.5966 19.4713 21.3256 19.9986 20 20Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const Message2Icon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.125 6.25H6.875C5.71506 6.25124 4.60298 6.71258 3.78278 7.53278C2.96258 8.35298 2.50124 9.46506 2.5 10.625V29.375C2.50124 30.5349 2.96258 31.647 3.78278 32.4672C4.60298 33.2874 5.71506 33.7488 6.875 33.75H33.125C34.2849 33.7488 35.397 33.2874 36.2172 32.4672C37.0374 31.647 37.4988 30.5349 37.5 29.375V10.625C37.4988 9.46506 37.0374 8.35298 36.2172 7.53278C35.397 6.71258 34.2849 6.25124 33.125 6.25ZM32.0172 13.4867L20.7672 22.2367C20.5478 22.4073 20.2779 22.4998 20 22.4998C19.7221 22.4998 19.4522 22.4073 19.2328 22.2367L7.98281 13.4867C7.85064 13.3869 7.73961 13.2618 7.6562 13.1187C7.57278 12.9756 7.51864 12.8174 7.49691 12.6532C7.47519 12.489 7.48631 12.3221 7.52964 12.1622C7.57296 12.0024 7.64763 11.8527 7.7493 11.7219C7.85096 11.5912 7.9776 11.4819 8.12186 11.4005C8.26611 11.3191 8.42511 11.2672 8.5896 11.2478C8.75409 11.2284 8.9208 11.2419 9.08004 11.2874C9.23928 11.333 9.38787 11.4098 9.51719 11.5133L20 19.6664L30.4828 11.5133C30.7449 11.3153 31.0744 11.2285 31.4001 11.2716C31.7257 11.3147 32.0213 11.4842 32.2229 11.7435C32.4245 12.0028 32.516 12.3311 32.4775 12.6573C32.439 12.9835 32.2736 13.2815 32.0172 13.4867Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
// const ShareIcon = () => {
//   return (
//     <svg
//       width="40"
//       height="41"
//       viewBox="0 0 40 41"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         fill-rule="evenodd"
//         clip-rule="evenodd"
//         d="M23.0057 9.38705C23.0057 6.32038 25.5056 3.83205 28.5856 3.83205C29.317 3.83008 30.0415 3.97222 30.7178 4.25036C31.3942 4.5285 32.0091 4.93718 32.5275 5.45306C33.0458 5.96893 33.4574 6.58188 33.7388 7.25689C34.0202 7.93191 34.1658 8.65575 34.1673 9.38705C34.1673 12.4554 31.6673 14.9437 28.5856 14.9437C27.8467 14.9443 27.115 14.7981 26.4329 14.5137C25.7508 14.2293 25.132 13.8124 24.6123 13.2871L16.8873 18.5471C17.1021 19.6187 16.9966 20.7299 16.584 21.7421L25.054 27.3087C26.0519 26.4956 27.3001 26.0522 28.5873 26.0537C29.3186 26.052 30.0431 26.1943 30.7194 26.4727C31.3956 26.751 32.0104 27.1599 32.5286 27.6759C33.0468 28.1919 33.4583 28.805 33.7394 29.4801C34.0206 30.1552 34.166 30.8791 34.1673 31.6104C34.1673 34.677 31.6673 37.1654 28.5856 37.1654C27.8545 37.1671 27.1301 37.0248 26.454 36.7466C25.7778 36.4684 25.1631 36.0596 24.6449 35.5438C24.1268 35.0279 23.7153 34.4151 23.434 33.7402C23.1527 33.0653 23.0072 32.3415 23.0057 31.6104C23.0044 30.8314 23.1685 30.0611 23.4873 29.3504L15.084 23.8321C14.066 24.7164 12.7624 25.2024 11.414 25.2004C10.6827 25.2021 9.95819 25.0598 9.28193 24.7814C8.60566 24.5031 7.99087 24.0942 7.47267 23.5782C6.95448 23.0622 6.54304 22.4491 6.26186 21.774C5.98069 21.0989 5.8353 20.375 5.83398 19.6437C5.83551 18.9126 5.98107 18.1889 6.26234 17.5139C6.54361 16.839 6.95509 16.2262 7.47326 15.7103C7.99143 15.1945 8.60615 14.7857 9.28231 14.5075C9.95847 14.2293 10.6828 14.087 11.414 14.0887C13.1873 14.0887 14.764 14.9104 15.7857 16.1904L23.274 11.0921C23.0954 10.5414 23.0048 9.96597 23.0057 9.38705Z"
//         fill="var(--primary-color)"
//       />
//     </svg>
//   );
// };
export const AddressLink: React.FC<{ address: string; className?: string }> = ({
  address,
  className = "",
}) => (
  <a
    href={`https://www.google.com/maps/search/?q=${encodeURIComponent(
      address
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    className={` hover:underline ${className}`}
  >
    {address}
  </a>
);
const EmailLink: React.FC<{ email: string; className?: string }> = ({
  email,
  className = "",
}) => (
  <a href={`mailto:${email}`} className={` hover:underline ${className}`}>
    {email}
  </a>
);

export interface Service {
  icon: React.ReactNode;
  header: string;
  text: string;
  className?: string; // Making className optional
}

export interface ExtendedService extends Service {
  className?: string;
}

export const Card2: React.FC<ExtendedService> = ({
  icon,
  header,
  text,
  className,
}) => {
  return (
    <div
      style={{
        boxShadow: "0px 1.64px 20.5px 0px #21212114",
      }}
      className={`relative select-none bg-white h-full w-[450px] flex gap-4 p-4 rounded-xl ${
        className || ""
      }`}
    >
      <Small type="top" />
      <Small type="bottom" />
      <div className="first bg-themeColor grid place-items-center rounded-md aspect-square size-[3.6rem]">
        <span>{icon}</span>
      </div>
      <div className="second flex flex-col">
        <h5 className="text-base text-primary mb-1 font-semibold">{header}</h5>
        <p className="text-secondary-main text-sm">{text}</p>
      </div>
    </div>
  );
};

const Small: React.FC<{ type: "top" | "bottom" }> = ({ type }) => {
  return (
    <div
      className={` size-6 absolute  border-themeColor ${
        type === "top"
          ? "top-4 border-r-[1.64px] rounded-tr-xl border-t-[1.64px] right-4"
          : "bottom-4 border-l-[1.64px] rounded-bl-xl border-b-[1.64px] left-4"
      }`}
    ></div>
  );
};
